import { StandardError } from "ecloud-base-connector";
import { BaseModel } from "./_base.model";

export class ImportResult extends BaseModel {
	static readonly modelName = "stockOrder";
	static readonly fields = {
		success: "success",
		result: "result",
		errorTrace: "error_trace",
		errorMessage: "error_message"
	};
	static readonly requiredFields = [];

	success: boolean;
	result: any;
	errorTrace: string;
	errorMessage: string;

	populate(modelData: any) {
		try {
			ImportResult.checkPopulateData(modelData, ImportResult.requiredFields);

			this.success = modelData[ImportResult.fields.success];
			this.result = modelData[ImportResult.fields.result];
			this.errorTrace = modelData[ImportResult.fields.errorTrace];
			this.errorMessage = modelData[ImportResult.fields.errorMessage];
		} catch (error) {
			throw new StandardError(error, "Invalid model data for ImportResult");
		}
	}

	toJson(): any {
		return {
			[ImportResult.fields.success]: this.success,
			[ImportResult.fields.result]: this.result,
			[ImportResult.fields.errorTrace]: this.errorTrace,
			[ImportResult.fields.errorMessage]: this.errorMessage
		};
	}

	getChanges(newModel: ImportResult) {
		const existentEModelData = this.toJson();
		const newEModelData = newModel.toJson();

		const changes: any = {};
		for (const field of Object.values(ImportResult.fields))
			if (existentEModelData[field] != newEModelData[field])
				changes[field] = newEModelData[field];

		return changes;
	}

	clone() {
		const newModel = new ImportResult();
		newModel.success = this.success;
		newModel.result = this.result;
		newModel.errorTrace = this.errorTrace;
		newModel.errorMessage = this.errorMessage;
		return newModel;
	}
}